import './StaffTypeAbbr.css';

/**
 * Compact staff-type abbreviation for table headers / dense UI.
 * Truncates with ellipsis when too long; hover shows full abbreviation + display name.
 */
export default function StaffTypeAbbr({
    abbreviation,
    displayName,
    suffix = '',
    maxWidth = '4.5rem',
    className = '',
}) {
    const abbr = String(abbreviation || '').trim();
    const name = String(displayName || '').trim();
    const title =
        name && name !== abbr ? `${abbr} — ${name}` : abbr || undefined;

    return (
        <span className={`staff-type-abbr-wrap ${className}`.trim()} title={title}>
            <span className="staff-type-abbr" style={{ maxWidth }}>
                {abbr}
            </span>
            {suffix ? <span className="staff-type-abbr-suffix">{suffix}</span> : null}
        </span>
    );
}
